
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { StreamConfigInterface } from './stream.types';

const STREAMS = {
  "iss_dl1": "ISS Live Stream (DL1)",
  "iss_dl6": "ISS EHDC (DL6)",
}

@Component
export default class StreamConfigComponent extends Vue {
  @Prop() config!: StreamConfigInterface;

  get streams() {
    return Object.entries(STREAMS).map((s) => ({text: s[1], value: s[0]}));
  }
  
  get streamid() {
    return this.config.streamid;
  }
  set streamid(id) {
    this.config.streamid = id;
  }

  get streamautoplay() {
    if (!this.config.hasOwnProperty("autoplay")) Vue.set(this.config, 'autoplay', true)
    return this.config.autoplay
  }
  set streamautoplay(value) {
    this.config.autoplay = value;
  }

  get streammute() {
    if (!this.config.hasOwnProperty("mute")) Vue.set(this.config, 'mute', true)
    return this.config.mute
  }
  set streammute(value) {
    this.config.mute = value;
  }

  get streamcontrols() {
    if (!this.config.hasOwnProperty("controls")) Vue.set(this.config, 'controls', true)
    return this.config.controls
  }
  set streamcontrols(value) {
    this.config.controls = value;
  }

  @Watch('config')
  onConfigChange(value: StreamConfigInterface) {
    this.$emit('update:config', value);
  }
};

